const env = import.meta.env;

export const APPENV = {
  AZURE_APP_CLIENT_ID: env.VITE_POWERAPP_AZURE_APP_CLIENT_ID,
  AZURE_APP_TENANT_ID: env.VITE_POWERAPP_AZURE_APP_TENANT_ID,
  DATAVERSE_SCOPE: env.VITE_DATAVERSE_SCOPE,
  DATAVERSE_BASE_URL: env.VITE_DATAVERSE_BASE_URL,
  MIDDLEWARE_BASE_URL: env.VITE_MIDDLEWARE_BASE_URL,
  MIDDLEWARE_FUNCTION_CODE: env.VITE_MIDDLEWARE_FUNCTION_CODE,
  // Legacy backend URL (kept for backward compatibility)
  BACKEND_BASE_URL: env.VITE_BACKEND_BASE_URL,
  POST_APP_JSON_CODE: env.VITE_POST_APP_JSON_CODE,
  GET_APP_JSON_CODE: env.VITE_GET_APP_JSON_CODE,
  ACCOUNT_DISCOUNT_CODE: env.VITE_ACCOUNT_DISCOUNT_CODE,
  DEFAULT_OMSCHEDULE_ID: env.VITE_DEFAULT_OMSCHEDULE_ID,
  UOMID: env.VITE_UOMID,
  DEFAULT_BUSINESS_UNIT_ID: env.VITE_DEFAULT_BUSINESS_UNIT_ID,
  AI_SERVICE_BASE_URL: env.VITE_AI_SERVICE_BASE_URL,
};
